import { useState } from "react";
import { Save, Check, Loader2, ToggleLeft, ToggleRight } from "lucide-react";
const T = { primary:"#f97316",primaryDark:"#ea580c",primaryLight:"#fff7ed",primaryMid:"#fed7aa",white:"#ffffff",bg:"#f1f5f9",text:"#0f172a",textSub:"#64748b",textMuted:"#94a3b8",border:"#e2e8f0",green:"#16a34a",greenLight:"#dcfce7" };
export default function SettingsPage() {
  const [settings, setSettings] = useState({
    appName:"Quickry", city:"Akola", deliveryFee:30, platformFee:5, freeDeliveryAbove:299,
    minOrderAmount:99, maxDeliveryRadius:10, estimatedDeliveryTime:30,
    foodEnabled:true, groceryEnabled:true, courierEnabled:true, medicineEnabled:false,
    maintenanceMode:false, newRegistrations:true, razorpayKey:"rzp_test_xxx", supportPhone:"9876543210", supportEmail:"support@quickry.in",
  });
  const [saving, setSaving] = useState(false);
  const [saved,  setSaved]  = useState(false);
  const set = (k,v) => setSettings(s=>({...s,[k]:v}));
  const handleSave = async () => { setSaving(true); await new Promise(r=>setTimeout(r,900)); setSaving(false); setSaved(true); setTimeout(()=>setSaved(false),2500); };
  const Toggle = ({ label, desc, k }) => (
    <div style={{ display:"flex",alignItems:"center",justifyContent:"space-between",padding:"13px 0",borderBottom:`1px solid ${T.border}` }}>
      <div><div style={{ fontWeight:600,fontSize:"0.87rem",color:T.text }}>{label}</div>{desc&&<div style={{ fontSize:"0.72rem",color:T.textMuted,marginTop:2 }}>{desc}</div>}</div>
      <div onClick={()=>set(k,!settings[k])} style={{ cursor:"pointer",color:settings[k]?T.primary:T.textMuted,flexShrink:0 }}>
        {settings[k]?<ToggleRight size={28}/>:<ToggleLeft size={28}/>}
      </div>
    </div>
  );
  const Field = ({ label, k, type="text" }) => (
    <div><div style={{ fontSize:"0.72rem",fontWeight:700,color:T.textSub,marginBottom:5 }}>{label}</div>
      <input type={type} value={settings[k]||""} onChange={e=>set(k,type==="number"?Number(e.target.value):e.target.value)}
        style={{ width:"100%",border:`1.5px solid ${T.border}`,borderRadius:10,padding:"9px 12px",fontSize:"0.85rem",color:T.text,background:T.bg,outline:"none",fontFamily:"inherit" }}/></div>
  );
  const SLabel = ({ children }) => <div style={{ fontSize:"0.62rem",fontWeight:700,color:T.textMuted,letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:14,marginTop:4 }}>{children}</div>;
  return (
    <div>
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
      {saved && <div style={{ position:"fixed",top:80,left:"50%",transform:"translateX(-50%)",background:T.text,color:"#fff",padding:"10px 20px",borderRadius:100,fontSize:"0.82rem",fontWeight:600,zIndex:500,display:"flex",alignItems:"center",gap:7 }}><Check size={14} color={T.green}/>Settings saved!</div>}
      <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,alignItems:"start" }}>
        {/* Left */}
        <div style={{ display:"flex",flexDirection:"column",gap:14 }}>
          <div style={{ background:T.white,borderRadius:16,border:`1px solid ${T.border}`,padding:"20px" }}>
            <SLabel>App Info</SLabel>
            <div style={{ display:"flex",flexDirection:"column",gap:12 }}>
              <Field label="App Name" k="appName"/>
              <Field label="City" k="city"/>
              <Field label="Support Phone" k="supportPhone"/>
              <Field label="Support Email" k="supportEmail"/>
            </div>
          </div>
          <div style={{ background:T.white,borderRadius:16,border:`1px solid ${T.border}`,padding:"20px" }}>
            <SLabel>Payment</SLabel>
            <Field label="Razorpay Key ID" k="razorpayKey"/>
          </div>
        </div>
        {/* Right */}
        <div style={{ display:"flex",flexDirection:"column",gap:14 }}>
          <div style={{ background:T.white,borderRadius:16,border:`1px solid ${T.border}`,padding:"20px" }}>
            <SLabel>Delivery Settings</SLabel>
            <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:12 }}>
              <Field label="Base Delivery Fee (₹)" k="deliveryFee" type="number"/>
              <Field label="Platform Fee (₹)" k="platformFee" type="number"/>
              <Field label="Free Delivery Above (₹)" k="freeDeliveryAbove" type="number"/>
              <Field label="Min Order (₹)" k="minOrderAmount" type="number"/>
              <Field label="Max Radius (km)" k="maxDeliveryRadius" type="number"/>
              <Field label="Est. Delivery (min)" k="estimatedDeliveryTime" type="number"/>
            </div>
          </div>
          <div style={{ background:T.white,borderRadius:16,border:`1px solid ${T.border}`,padding:"20px" }}>
            <SLabel>Services</SLabel>
            <Toggle label="Food Delivery"   k="foodEnabled"        desc="Enable restaurant food orders"/>
            <Toggle label="Grocery Delivery" k="groceryEnabled"    desc="Enable grocery store orders"/>
            <Toggle label="Courier / Pickup" k="courierEnabled"    desc="Enable parcel delivery"/>
            <Toggle label="Medicine Delivery" k="medicineEnabled"  desc="Coming soon — enable when ready"/>
          </div>
          <div style={{ background:T.white,borderRadius:16,border:`1px solid ${T.border}`,padding:"20px" }}>
            <SLabel>System</SLabel>
            <Toggle label="Maintenance Mode"   k="maintenanceMode"   desc="Show maintenance screen to users"/>
            <Toggle label="New Registrations"  k="newRegistrations"  desc="Allow new users to sign up"/>
          </div>
        </div>
      </div>
      <div style={{ marginTop:20,display:"flex",justifyContent:"flex-end" }}>
        <button onClick={handleSave} disabled={saving} style={{ background:T.primary,border:"none",borderRadius:12,padding:"12px 32px",fontWeight:800,fontSize:"0.92rem",cursor:"pointer",color:"#fff",fontFamily:"inherit",display:"flex",alignItems:"center",gap:8 }}>
          {saving?<><Loader2 size={16} style={{ animation:"spin .75s linear infinite" }}/>Saving...</>:<><Save size={16}/>Save Settings</>}
        </button>
      </div>
    </div>
  );
}
